app.service('vueData', function ($global, console) {
	var vueData = {};
	function getVue() {
		return vueData;
	}
	function setVue(data) {
		console.log('setVue', data);
		vueData = data;
		$('#vue-script').remove();
	}
	$global('setVue', setVue);
	return {
		getVue
	};
});